const IamLegalEntitiesIconSubcategory = () => (
  <svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="72" height="72" rx="14.5455" fill="url(#paint0_linear_4435_11541)" />
    <g clip-path="url(#clip0_4435_11541)">
      <path
        d="M35.45 18.1002C36.15 18.1002 36.85 18.1002 37.55 18.4002L51.15 25.6002C52.85 26.5002 52.55 28.9002 50.75 29.5002C41.15 29.8002 31.55 29.5002 21.95 29.6002C20.55 29.5002 19.65 28.6002 19.85 27.2002C20.05 25.8002 21.05 25.6002 22.05 25.0002C25.85 22.9002 30.15 20.6002 34.05 18.7002C37.95 16.8002 35.05 18.2002 35.55 18.1002H35.45Z"
        fill="white"
      />
      <path
        d="M22.1499 48.4001H49.7499C52.9499 48.6001 53.1499 52.9001 50.0499 53.5001H21.9499C19.0499 52.9001 19.1499 48.8001 22.1499 48.4001Z"
        fill="white"
      />
      <path
        d="M25.5496 33C26.8496 32.9 28.1496 33.9 28.2496 35.3C28.4496 37.7 28.0496 40.5001 28.2496 43.0001C27.4496 46.0001 23.3496 45.6 23.1496 42.5001C22.9496 39.4001 23.0496 37.5 23.1496 35.7C23.2496 33.9 24.1496 33.3 25.5496 33.1V33Z"
        fill="white"
      />
      <path
        d="M35.8504 33C37.1504 32.9 38.4504 33.9 38.5504 35.3C38.7504 37.7 38.3504 40.5001 38.5504 43.0001C37.7504 46.0001 33.6504 45.6 33.4504 42.5001C33.2504 39.4001 33.3504 37.5 33.4504 35.7C33.5504 33.9 34.4504 33.3 35.8504 33.1V33Z"
        fill="white"
      />
      <path
        d="M46.0496 33C47.3496 32.9 48.6497 33.9 48.7497 35.3C48.9496 37.7 48.5497 40.5001 48.7497 43.0001C47.9496 46.0001 43.8496 45.6 43.6496 42.5001C43.4496 39.4001 43.5496 37.5 43.6496 35.7C43.7496 33.9 44.6496 33.3 46.0496 33.1V33Z"
        fill="white"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_4435_11541"
        x1="35.5325"
        y1="2.5289e-06"
        x2="91.0286"
        y2="43.2"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#6600E8" />
        <stop offset="1" stop-color="#BD0044" />
      </linearGradient>
      <clipPath id="clip0_4435_11541">
        <rect width="37.5" height="36.4" fill="white" transform="translate(17.25 17.8)" />
      </clipPath>
    </defs>
  </svg>
)

export default IamLegalEntitiesIconSubcategory
